export default {
  url_api: 'https://api.merx.app.br',
}
